import { ADD_USERS, APPROVED_SUB_USER, DELETE_USERS, GET_USERS, LOG_OUT_SUB_USER, MAX_LOGIN_USERS, RESET_USER_PASSWORD, UPDATE_SUB_USER_MULTI_LOGIN, UPDATE_USER_CRED, UPDATE_USERS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getUsers = (payload) => {
  return apiInstance.post(GET_USERS, payload);
};
export const addUsers = (payload) => {
  return apiInstance.post(ADD_USERS, payload);
};
export const updateUsers = (payload) => {
  return apiInstance.post(UPDATE_USERS, payload);
};
export const deletUsers = (payload) => {
  return apiInstance.post(DELETE_USERS, payload);
};
export const updateCred = (payload) => {
  return apiInstance.post(UPDATE_USER_CRED, payload);
};
export const updateSubUserMultiLogin = (payload) => {
  return apiInstance.post(UPDATE_SUB_USER_MULTI_LOGIN, payload);
};
export const resetUserPassword = (payload) => {
  return apiInstance.post(RESET_USER_PASSWORD, payload);
};
export const logoutUser = (payload) => {
  return apiInstance.post(LOG_OUT_SUB_USER, payload);
};
export const maxLoginUsers = (payload) => {
  return apiInstance.post(MAX_LOGIN_USERS, payload);
};
export const approvedUser = (payload) => {
  return apiInstance.post(APPROVED_SUB_USER, payload);
};